import { useState, useEffect } from "react";
import { AdminLayout } from "./features/admin";
import { Dashboard } from "./features/dashboard";
import { ProducersPage } from "./features/producers";
import { HistoryPage } from "./features/history";
import { ProfilePage } from "./features/profile";
import { SettingsPage } from "./features/settings";
import { useLogin, LoginPage } from "./features/auth";
import { BouncingDots } from "./shared/components/BouncingDots";
import "./index.css";

export function App() {
  const [activePage, setActivePage] = useState(() => {
    return localStorage.getItem('cotagro_admin_active_page') || 'home';
  });
  
  const auth = useLogin();

  // Reset page to home when logging out or not authenticated
  useEffect(() => {
    if (auth.step !== "AUTHENTICATED") {
      setActivePage('home');
      localStorage.setItem('cotagro_admin_active_page', 'home');
    }
  }, [auth.step]);

  const handlePageChange = (page: string) => {
    setActivePage(page);
    localStorage.setItem('cotagro_admin_active_page', page);
  };

  if (auth.isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <BouncingDots />
      </div>
    );
  }

  if (auth.step !== "AUTHENTICATED") {
    return <LoginPage auth={auth} />;
  }

  return (
    <AdminLayout 
      activePage={activePage} 
      onPageChange={handlePageChange}
      onLogout={auth.handleLogout}
      userProfile={auth.userProfile}
    >
      {activePage === 'home' && <Dashboard />}
      {activePage === 'productores' && <ProducersPage />}
      {activePage === 'historial' && <HistoryPage />}
      {activePage === 'configuracion' && <SettingsPage />}
      {activePage === 'perfil' && <ProfilePage userProfile={auth.userProfile} onProfileUpdated={auth.refreshProfile} />}
    </AdminLayout>
  );
}

export default App;
